import selectSingleElement from "../dom/selectSingleElement";
import { KNIT_BEANIE_STYLE } from "./_selectors";
import { getBeanieTextDivs } from "./getBeanieTextDivs";
import knitBeanieStyleButtonHandleClick from "./knitBeanieStyleHandleClick";

export default function beanieSetup() {
	getBeanieTextDivs().hide();
	const knitBeanieStyleButton = selectSingleElement<HTMLSpanElement>(KNIT_BEANIE_STYLE);
	if (knitBeanieStyleButton === null) return;

	knitBeanieStyleButton.addEventListener("click", knitBeanieStyleButtonHandleClick);
}
